function Failover(options) {
  var data = {}, options = options || {};

  var baseCloudUrl = '/cloud/';
  var baseAjaxUrl  = '/cloud_ajax/';

  let lastEditEl = null;

  const PS_PASSWORD_PROTECTED_KEY = 'ps_has_password';

  function _init(el) {
    if (el && el.data.length) {
      data = el.data();
    } else {
      console.log('Failover init failed. No data available.');
    }
  }

  function _do(action, callback) {
  	var dataForAction = data;
    $.ajax({
      url: baseAjaxUrl + action,
      type: 'POST',
      data: dataForAction,
      dataType: 'json',
      error: ajax_error_handler,
      success: function(rv, status){
        if (rv['is_error']) {
          handleErrors(rv);
          return;
        } else {
          gtag('event', 'Hotsite', {
            'event_category': action + ' completed',
            'event_label': `client: ${dataForAction.client_id}, appliance: ${dataForAction.service_id}, failover: ${dataForAction.failover_id}, server: ${dataForAction.server_id}`
          });
        }

        if (typeof callback == "function") { callback(rv); }
      }
    });

    gtag('event', 'Hotsite', {
      'event_category': action + ' action',
      'event_label': `client: ${dataForAction.client_id}, appliance: ${dataForAction.service_id}, failover: ${dataForAction.failover_id}, server: ${dataForAction.server_id}`
    });
  }

  function handleErrors(response) {
    if (response['errors'][PS_PASSWORD_PROTECTED_KEY]) {
      loadStartVmWithPassword();
    } else {
      _error_dlg(response['errors']['_message_']);
      gtag('event', 'Hotsite', {
        'event_category': action + ' failed',
        'event_label': `client: ${dataForAction.client_id}, appliance: ${dataForAction.service_id}, failover: ${dataForAction.failover_id}, server: ${dataForAction.server_id}`
      });
      if (options.onErrorCallback) {
        options.onErrorCallback(dataForAction);
      }
    }
  }

  function loadStartVmWithPassword() {
    const startVmDialogId = data.server_id + '_enter_vm_password_dlg';
    $('#content').after('<div id="' + startVmDialogId + '" style="display: none;"></div>');

    const defer = $.Deferred().done(function() {
      var dlg = _create_dialog(startVmDialogId, {
        title: _vm_password_dialog_title,
        width: '450',
        minWidth: '400',
        minHeight: '150'
      });
      dlg.dialog('open');
    });

    const passwordDialog = $('#' + startVmDialogId);

    passwordDialog.load('/dialog/enter_vm_password', function() {
      const startVmButton = passwordDialog.find('.js-start-vm');
      passwordDialog.find('.js-close').click(function () {
        passwordDialog.dialog('destroy').remove();
      });
      passwordDialog.find('[name="password"]').keyup(function(event) {
        if (event.currentTarget.value.length > 0) {
          startVmButton.removeClass("disabled");
        } else {
          startVmButton.addClass("disabled");
        }
      });
      startVmButton.click(function () {
        passwordDialog.find('input').parent().removeClass('error');
        const password = passwordDialog.find('[name="password"]').val();
        data.password = password;
        data.start_password_protected = true;
        $.ajax({
          url: baseAjaxUrl + 'start_vm',
          type: 'POST',
          data: data,
          dataType: 'json',
          error: ajax_error_handler,
          success: function(rv, status){
            if (rv['is_error']) {
              for (const key in rv['errors']) {
                const inputField = passwordDialog.find('[name="' + key + '"]');
                inputField.parent().addClass('error');
                inputField.parent().find('.error-text').html(rv['errors'][key]);
              }
            } else {
              passwordDialog.dialog('destroy').remove();
            }
          }
        });
      });
      defer.resolve();
    });
  }

  function _create_dialog(id, custom) {
    var dlg = $('#' + id);
    var params = {
      modal: true,
      width: '700',
      minWidth: '530',
      minHeight: '350',
      draggable: false,
      resizable: false,
      closeText: _close_label,
      dialogClass: 'axDialog',
      title: '',
      close: function() {
        $(this).dialog('destroy').remove();
      },
      buttons: []
    };

    $.each(params, function(i) {
      if (typeof custom[i] != "undefined") {
        params[i] = custom[i];
      }
    });

    return dlg.dialog(params);
  }

  var restoreEditVMDialogButtons = function () {
    var editVmContentButtons = $('.edit-vm-content .axButtons');
    editVmContentButtons.find('.js-cancel').show();
    editVmContentButtons.find('.js-edit_vm').show();
    editVmContentButtons.find('.js-ok').hide();
  };

  var configureSlider = function ($dialog, $slider, amountSelector) {
    var max = $slider.data('max'),
        value = $slider.data('alloc') || 1,
        $amount = $dialog.find(amountSelector),
        $using = $amount.find('.using'),
        $input = $amount.find('input'),
        ramConfig = {
          range: 'min',
          min: 1,
          max: max,
          step: 1,
          value: value,
          slide: function(event, ui) {
            $using.text(ui.value);
            $input.val(ui.value);
            $input.valid();
            restoreEditVMDialogButtons();
          }
        };
    $slider.slider(ramConfig);
    $input.on('input', function() {
      if ($input.valid()) {
        $using.text(this.value);
        $slider.slider('value', this.value);
      }
    });
    $using.text(value);
    $input.val(value);
  }

  var buildSliders = function(dialog) {
    var $ramSlider = dialog.find('.vm-ram-slider'), $cpuSlider = dialog.find('.vm-cpu-slider');
    configureSlider(dialog, $ramSlider, '.js-vm-ram-slider-amount');
    configureSlider(dialog, $cpuSlider, '.js-vm-cpu-slider-amount');

    dialog.find('form').validate({
      errorElement: 'span',
      errorPlacement: function(error, element) {
        error.addClass('feedback16-icon error field-error js-validation-' + element.attr('name'));
        error.attr('data-axtooltip-class', 'error');
        error.insertAfter(element);
      },
      showErrors(errorMap, errorList) {
        this.defaultShowErrors();
        errorList.forEach(function(error) {
          var $validationLabel = dialog.find('.js-validation-' + error.element.name);
          $validationLabel.attr('data-axtooltip', $validationLabel.text());
          $validationLabel.text('');
        });
      },
      rules: {
        cpu: {
          required: true,
          digits: true,
          range: [1, $cpuSlider.data('max')],
        },
        ram: {
          required: true,
          digits: true,
          range: [1, $ramSlider.data('max')],
        }
      },
      messages: {
        cpu: {
          range: jQuery.validator.format(failover_edit_plain_text_cpu_ram_validation)
        },
        ram: {
          range: jQuery.validator.format(failover_edit_plain_text_cpu_ram_validation)
        }
      }
    });
  };

  var getRamValue = function($dialog){
  	var $ramSlider = $dialog.find('input[name=vm-ram-slider]');
		return ($ramSlider.length > 0)
				? $ramSlider.val()
				: $dialog.find('.vm-ram-slider').slider('value');
  };

  var getCoresValue = function($dialog){
		var $cpuSlider = $dialog.find('input[name=vm-cpu-slider]');
		return ($cpuSlider.length > 0)
				? $cpuSlider.val()
				: $dialog.find('.vm-cpu-slider').slider('value');
  };

  this.render = function(el) {
    _init(el);
    var dialog_id = data.server_id + '_render_dlg';
    $('#content').after('<div id="' + dialog_id + '" style="display:none;"></div>');

    var deferred = $.Deferred().done(function() {
      var dlg = _create_dialog(dialog_id, {
        title: _render_dialog_title
      });
      dlg.dialog('open');

      var formatRP = function(data){
        var restorePoint = $('<span class="disk-letters-container"></span>').text(data.text.trim());
        if (data.element[0].dataset.disabled > 0) {
          restorePoint.prepend('<span class="icon-alarm"></span>');
        }
        var disksStr = data.element[0].dataset.disks.trim();
        var offsiteCompleted = data.element[0].dataset.offsite_completed != 0;
        restorePoint.attr('data-offsite-completed', offsiteCompleted);
        if(disksStr.length > 0){
          var disks = disksStr.split('');
          disks.forEach(function(item, i, arr){
            var diskLetter = $('<span class="disk-letter"></span>').text(item + ':');
            restorePoint.append(diskLetter);
          });
        }
        return restorePoint;
      };

      var formatRPSelected = function(data){
        var rpText = $('<span class="restore-point-text"></span>').text(data.text.trim());
        var disksContainer = $('<span class="disks-container"></span>');
        var disksStr = data.element[0].dataset.disks.trim();
        var offsiteCompleted = data.element[0].dataset.offsite_completed != 0;
        if(disksStr.length > 0){
          var tooltipDisks = '';
          var disks = disksStr.split('');
          disks.forEach(function(item, i, arr){
            var disk = $('<span class="disk"></span>').text(item + ':');
            disksContainer.append(disk);
            tooltipDisks += item + ': ';
          });
          disksContainer.attr('data-axTooltip', tooltipDisks);
          disksContainer.attr('data-axTooltip-trunc', true);
          disksContainer.attr('data-offsite-completed', offsiteCompleted);
        }
        $('.restore_points .select2-chosen').append(rpText).append(disksContainer);
      }

      var isAllDisabled = true;
      dlg.find('#vo_restore_points option').each(function(i, item) {
        if (!$(item).prop('disabled')) {
          isAllDisabled = false;
          return false;
        }
      });

      let options = {
        minimumResultsForSearch: -1,
        dropdownCssClass: 'select2-render-form',
        formatResult: formatRP,
        formatSelection: formatRPSelected,
        escapeMarkup: function(m){ return m; }
      };
      if (isAllDisabled) {
        options.placeholder = rmclang.label_none_dropdown;
        dlg.find('#vo_restore_points').prepend(' <option></option>');
        dlg.find('.render_vm').prop('disabled', true);
      }
      dlg.find('#vo_restore_points').select2(options);
    });

    var $dialog = $('#' + dialog_id);
    $dialog.load(baseCloudUrl + 'load_render_dialog/' + data.failover_id, data, function() {
      buildSliders($dialog);
      const $safeBoot = $dialog.find('#safe_boot_toggle');
      if ($safeBoot.length) {
        emulateCheck($safeBoot.attr('id'));
        $safeBoot.on('change', event => {
          emulateCheck(event.currentTarget.id);
        });
      }

      //cancel button
			$dialog.find('.cancel').click(function() { $dialog.dialog('destroy').remove(); });
      //render button
      var $cpuInput = $dialog.find('.js-vm-cpu-slider-amount input'),
          $ramInput = $dialog.find('.js-vm-ram-slider-amount input'),
          $errorMessageBlock = $dialog.find('.infobox--error');
      $dialog.find('.render_vm').click(function() {
        if ($cpuInput.valid() && $ramInput.valid()) {
          $errorMessageBlock.hide();
          data.ram = getRamValue($dialog);
          data.cores = getCoresValue($dialog);
          data.restore_point = $dialog.find('#vo_restore_points').val();
          data.safe_boot = $safeBoot.prop('checked');
          forceUpdateAndHideButtons();
          _do('start_render');

          $dialog.dialog('destroy').remove();
        } else {
          $errorMessageBlock.fadeIn();
        }
      });

      deferred.resolve();
    });
  };

  this.cancel = function(el) {
    _init(el);
    forceUpdateAndHideButtons();
    _do('cancel_render');
  };

  this.start = function(el) {
    _init(el);
    forceUpdateAndHideButtons();
    _do('start_vm');
  };

  this.edit_vm_limits = function (el) {
    _init(el);
    var dialog_id = data.server_id + '_edit_vm_limits_dlg';
    var dialogConfirmId = data.server_id + '_edit_vm_limits_confirm_dlg';
    var $content = $('#content');
    $content.after('<div id="' + dialog_id + '" style="display: none;"></div>');
    $content.after('<div id="' + dialogConfirmId + '" style="display: none;"></div>');

    var createDialog = function (dialogId) {
      var dlg = _create_dialog(dialogId, {
        title: _failover_edit_vm_limits_dialog_title,
        width: '500',
        minWidth: '350',
        minHeight: '150'
      });
      dlg.dialog('open');
    };
    var closeDialog = function (dialog) {
      dialog.dialog('destroy').remove();
    };

    var deferEditDialog = $.Deferred().done(createDialog);

    var $editVmLimitsDialog = $('#' + dialog_id);
    $editVmLimitsDialog.load(baseCloudUrl + 'load_edit_vm_limits/', data, function () {
      var $dialogContent = $('.edit-vm-resources-limits-content');
      var $coreCombobox = $("select#core_max_val");
      var $ramCombobox = $("select#ram_max_val");

      $coreCombobox.combobox({readonly: true, appendTo: $dialogContent});
      $ramCombobox.combobox({readonly: true, appendTo: $dialogContent});

      $editVmLimitsDialog.find('.js-cancel, .close').click(function () {
        $editVmLimitsDialog.dialog('destroy').remove();
      });
      $editVmLimitsDialog.find('.js-edit_vm_limits').click(function () {
        data.max_cpu_cores = $coreCombobox.val();
        data.max_ram = $ramCombobox.val();
        $.post(baseAjaxUrl + "save_vm_resource_limits", data, function () {
          closeDialog($editVmLimitsDialog);
        })
      });
      $editVmLimitsDialog.find('.js-ok').click(function () {
        closeDialog($editVmLimitsDialog);
      });
      deferEditDialog.resolve(dialog_id);
    });
  };

  this.edit = function(el, confirmationDlg) {
    _init(el);
    lastEditEl = el;
    var dialog_id = data.server_id + '_edit_vm_dlg';
    var dialogConfirmId = data.server_id + '_edit_vm_confirm_dlg';
    var $content = $('#content');
    $content.after('<div id="' + dialog_id + '" style="display: none;"></div>');
		$content.after('<div id="' + dialogConfirmId + '" style="display: none;"></div>');

    var createDialog = function(dialogId){
      var dlg = _create_dialog(dialogId, {
        title: _failover_edit_dialog_title,
        width: '700',
        minWidth: '350',
        minHeight: '150'
      });
      dlg.dialog('open');
      if (confirmationDlg) {
        confirmationDlg.dialog('destroy').remove();
      }
    };
    var closeDialog = function(dialog){
      dialog.dialog('destroy').remove();
    };

    var deferEditDialog = $.Deferred().done(createDialog);
    var deferConfirmDialog = $.Deferred().done(createDialog);

    var $editDialog = $('#' + dialog_id);
		$editDialog.load(baseCloudUrl + 'load_edit_vm/', data, function() {
      buildSliders($editDialog);

			$editDialog.find('.js-cancel, .close').click(function(){ $editDialog.dialog('destroy').remove(); });

      var $cpuInput = $editDialog.find('.js-vm-cpu-slider-amount input'),
          $ramInput = $editDialog.find('.js-vm-ram-slider-amount input'),
          $errorMessageBlock = $editDialog.find('.infobox--error');
			$editDialog.find('.js-edit_vm').click(function() {
        if ($cpuInput.valid() && $ramInput.valid()) {
          $errorMessageBlock.hide();
          data.ram = getRamValue($editDialog);
          data.cores = getCoresValue($editDialog);
          if(data.current_status == 'running'){
            var $confirmDlg = $('#' + dialogConfirmId);
            $confirmDlg.load('/dialog/edit_vm_confirm/', function(){
              $confirmDlg.find('.js-cancel').click(function(){ $confirmDlg.dialog('destroy').remove(); });
              $confirmDlg.find('.js-continue').click(function(){
                hideButtons();
                _do('edit_vm', function (rv) {
                  forceUpdate();
                });
                closeDialog($confirmDlg);
              });
              deferConfirmDialog.resolve(dialogConfirmId);
              closeDialog($editDialog);
            });
          } else {
            var editVmContent = $('.edit-vm-content');
            var cancelButton = editVmContent.find('.axButtons .js-cancel');
            var editButton = editVmContent.find('.axButtons .js-edit_vm');
            var okButton = editVmContent.find('.axButtons .js-ok');
            var successPane = editVmContent.find('.js-vm-settings-saving-success');
            var cpuSlider = editVmContent.find('.vm-cpu-slider');
            var ramSlider = editVmContent.find('.vm-ram-slider');
            successPane.hide();
            cancelButton.addClass('disabled');
            editButton.addClass('disabled');
            cpuSlider.slider('disable');
            ramSlider.slider('disable');
            _do('edit_vm', function (rv) {
              cancelButton.removeClass('disabled');
              editButton.removeClass('disabled');
              if (!rv['is_error']) {
                cancelButton.hide();
                editButton.hide();
                okButton.show();
                successPane.show();
                cpuSlider.slider('enable');
                ramSlider.slider('enable');
              }
            });
          }
        } else {
          $errorMessageBlock.fadeIn();
        }
      });
			$editDialog.find('.js-ok').click(function(){ closeDialog($editDialog); });
      deferEditDialog.resolve(dialog_id);
    });
  };

  this.stop = function(el) {
    _init(el);
    var dialog_id = data.server_id + '_stop_vm_dlg';
    $('#content').after('<div id="' + dialog_id + '" style="display: none;"></div>');

    var defer = $.Deferred().done(function() {
      var dlg = _create_dialog(dialog_id, {
        title: _failover_stop_dialog_title,
        width: '700',
        minWidth: '350',
        minHeight: '150'
      });
      dlg.dialog('open');
    });

    var $stopDialog = $('#' + dialog_id);
		$stopDialog.load(baseCloudUrl + 'load_stop_vm/' + data.failover_id + '/' + data.server_id, function() {
      // cancel button
			$stopDialog.find('.js-cancel').click(function() { $stopDialog.dialog('destroy').remove(); });
      // stop vm button
			$stopDialog.find('.js-stop').click(function() {
        data.stop_type = $stopDialog.find('input[name=stop_type]:checked').val();
        forceUpdateAndHideButtons();
        _do('stop_vm');
				$stopDialog.dialog('destroy').remove();
      });
      defer.resolve();
    });
  };

  this.stop_all = function(el) {
    _init(el);
    var dialog_id = data.client_id + '_stop_all_vms_dlg';
    $('#content').after('<div id="' + dialog_id + '" style="display: none;"></div>');

    var defer = $.Deferred().done(function() {
      var dlg = _create_dialog(dialog_id, {
        width: '700',
        minHeight: '200',
        title: _failover_stop_all_dialog_title
      });
      dlg.dialog('open');
    });

		var $stopAllDialog = $('#' + dialog_id);
		$stopAllDialog.load(baseCloudUrl + 'load_stop_all_vms/' + data.failover_id, function() {
      // cancel button
			$stopAllDialog.find('.js-cancel').click(function() { $stopAllDialog.dialog('destroy').remove(); });
      // stop vm button
			$stopAllDialog.find('.js-stop').click(function() {
        data.stop_type = $stopAllDialog.find('input[name=stop_type]:checked').val();
        _do('stop_all_vms');
        $stopAllDialog.dialog('destroy').remove();
      });
      defer.resolve();
    });
  };

  this.discard = function(el) {
    _init(el);
    let vmName = data.vm_name;
    let parentDialogId = data.server_id + '_edit_vm_dlg';
    var dialogId = data.server_id + 'discard_vm_dlg';
    $('#content').after('<div id="' + dialogId + '" style="display: none;"></div>');

    var defer = $.Deferred().done(function() {
      var dlg = _create_dialog(dialogId, {
        width: '700',
        minWidth: '350',
        minHeight: '150'
      });
      $('#' + dialogId).parent('.ui-dialog').find('.ui-dialog-title').html(_failover_discard_dialog_title.replace('%s', vmName))
      dlg.dialog('open');
    });

    var $discardDialog = $('#' + dialogId);
    let self = this;
		$discardDialog.load('/dialog/discard_vm', function(){
      // cancel button
			$discardDialog.find('.js-cancel').click(function() {
        self.edit(lastEditEl, $discardDialog);
      });
      // end failover button
			$discardDialog.find('.js-yes').click(function() {
        forceUpdateAndHideButtons();
        _do('discard_vm');
        $discardDialog.dialog('destroy').remove();
      });
      defer.resolve();

      $('#' + parentDialogId).dialog('close');
    });
  };

  this.login = function(el) {
    _init(el);
    newWin = window.open(baseCloudUrl + 'vm_login/' + data.failover_id + '/' + data.appliance_id + '/' + data.server_id);
    newWin.launcher = this;
  };

  this.stop_vnc = function(failover_id, service_id, server_id, appliance_id){

    gtag('event', 'Hotsite', {
      'event_category': 'failover - stop vnc',
      'event_label': `client: ${data.client_id}, appliance: ${data.service_id}, failover: ${data.failover_id}, server: ${data.server_id}`
    });

    $.ajax({
      type     : 'POST',
      url      : baseAjaxUrl + 'stop_vnc',
      dataType : 'json',
      data     : {
        failover_id   : failover_id,
        service_id    : service_id,
        server_id     : server_id,
        appliance_id  : appliance_id
      },
      error    : ajax_error_handler,
      success  : function(){ /* intentionally empty let window close */ }
    });
  };

  this.end = function(el) {
    _init(el);
    var dialog_id = data.client_id + '_end_failover_dlg';
    $('#content').after('<div id="' + dialog_id + '" style="display: none;"></div>');

    var defer = $.Deferred().done(function() {
      var dlg = _create_dialog(dialog_id, {
        width: '700',
        minHeight: '200',
        title: _end_failover_dialog_title
      });
      dlg.dialog('open');
    });

    var voPageHistoryState = window.history.state;

		var $failoverEndDialog = $('#' + dialog_id);
		$failoverEndDialog.load('/dialog/failover_end', function() {
      // cancel button
			$failoverEndDialog.find('.js-cancel').click(function(){ $failoverEndDialog.dialog('destroy').remove(); });
      //end failover button
			$failoverEndDialog.find('.js-yes').click(function() {
        gtag('event', 'Hotsite', {
          'event_category': 'failover - end start',
          'event_label': `client: ${data.client_id}, failover: ${data.failover_id}`
        });
        $failoverEndDialog.dialog('destroy').remove();
        _do('end_failover', function (rv) {
        	if (voPageHistoryState === window.history.state) {
            if (!rv['is_cc_error']) {
              checkFailoverErrors(data.client_id);
            }
            tabs_goto('client/details/' + data.client_id, 'li.clients-tab');
          }
        });
        showVODiscardingSpinner();
      });
      defer.resolve();
    });
  };
}
